"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isUsTerritory = exports.usTerritories = exports.CountryCodes = void 0;
exports.CountryCodes = {
    USA: 'US',
    AMERICAN_SAMOA: 'AS',
    GUAM: 'GU',
    NORTHERN_MARIANA: 'MP',
    PUERTO_RICO: 'PR',
    US_MINOR_OUTLYING_ISLANDS: 'UM',
    US_VIRGIN_ISLANDS: 'VI',
};
exports.usTerritories = [
    exports.CountryCodes.USA,
    exports.CountryCodes.AMERICAN_SAMOA,
    exports.CountryCodes.GUAM,
    exports.CountryCodes.NORTHERN_MARIANA,
    exports.CountryCodes.PUERTO_RICO,
    exports.CountryCodes.US_MINOR_OUTLYING_ISLANDS,
    exports.CountryCodes.US_VIRGIN_ISLANDS,
];
const isUsTerritory = (countryCode) => exports.usTerritories.includes(countryCode.toUpperCase());
exports.isUsTerritory = isUsTerritory;
//# sourceMappingURL=countries.js.map